App.factory('Provider', ['restmod', restmod => restmod.model('/providers')])